'use client';
import { useContext, useRef } from 'react';
import { Provider } from 'react-redux';
import { AppStore, InitialStoreState } from '../store/store';
import { LanguageContext } from '../providers/LanguageProvider';
import { getOrCreateStore } from '../store/global-store';

export default function StoreProvider({
  children,
  initialState,
}: {
  children: React.ReactNode;
  initialState?: InitialStoreState;
}) {
  const storeRef = useRef<AppStore>(undefined);
  const { texts } = useContext(LanguageContext);
  if (!storeRef.current) {
    // Create the store instance the first time this renders
    storeRef.current = getOrCreateStore(initialState, texts);
  }

  return <Provider store={storeRef.current}>{children}</Provider>;
}
